// useDimensionsStore.ts
import { create } from 'zustand'
import { Dimensions, ScaledSize } from 'react-native'

type DimensionsState = {
    width: number
    height: number
    orientation: 'portrait' | 'landscape'
    setDimensions: (dims: ScaledSize) => void
}

export const useDimensionsStore = create<DimensionsState>((set) => {
    const { width, height } = Dimensions.get('window')

    return {
        width,
        height,
        orientation: width > height ? 'landscape' : 'portrait',
        setDimensions: (dims) =>
            set({
                width: dims.width,
                height: dims.height,
                orientation: dims.width > dims.height ? 'landscape' : 'portrait',
            }),
    }
})

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export function useBreakpoint(): Breakpoint {
    const width = useDimensionsStore((state) => state.width)

    if (width < 768) return 'sm' // mobile grande / tablet chica
    if (width < 1024) return 'md' // tablet grande
    if (width < 1440) return 'lg' // desktop standard
    return 'xl' // desktop grande
}

export function useIsMobile(): boolean {
    const breakpoint = useBreakpoint()
    return breakpoint === 'sm'
}
